import React from 'react';
import { DataConsumer } from 'spark-grid';
import GridHeaderRow from 'spark-ui/Grid/header/GridHeaderRow';
import HeaderCell from 'spark-ui/Grid/header/headerCells/HeaderCell';
import { withStyles } from 'material-ui/styles';

const headerStyle = (theme) => ({
	head: {
		color: '#595959',
		fontWeight: 'bold',
		backgroundColor: '#e2e2e2',
		fontSize: '13px',
		padding: '4px 8px 4px 8px !important'
	},
	headerHeight: {
		height: '28px'
	}
});

const RecipientGridHeader = () => {
	return (
		<DataConsumer>
			{({ sorting }, { sort }) => (
				<GridHeaderRow>
					<HeaderCell label="Title" />
					<HeaderCell label="Status" />
					<HeaderCell label="Org" />
					<HeaderCell label="Product" />
					<HeaderCell label="Study" />
					<HeaderCell label="Sent Date" />
                    <HeaderCell label="Download" />
					<HeaderCell label="Action" />
				</GridHeaderRow>
			)}
		</DataConsumer>
	);
};

export default withStyles(headerStyle)(RecipientGridHeader);
